var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{staticClass:"themified-app"},[_c('AppMainLayout',{staticClass:"texto--text"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }